import { useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
import {AppValues, API, ApiAdmin, MAPS_API_KEY } from "../../Values";
import { useState, useMemo, useEffect, useRef } from "react";
import marker from "../../../Images/marker.png";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';  // استيراد الأنماط الخاصة بـ Geoman
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';  // استيراد الأنماط الخاصة بالبحث
import 'leaflet-control-geocoder';  // استيراد المكتبة الخاصة بالبحث
import L from 'leaflet';

const mapContainerStyle = {
  width: "100%",
  height: "80%",
};

const center_ = {
  lat: 30.033,
  lng: 31.233,
};

export default function DellerNavigation() {
  const navigate = useNavigate();
  const params = useParams();
  let [center, Setcenter] = useState(center_);
  const [DellerName, SetDelleName] = useState("");
  const [Dellerlocation, SetDellerlocation] = useState("");
  const fetchIntervalRef = useRef(null);
  const libraries = useMemo(() => ["places", "geometry"], []);
  const [isLoading, setIsLoading] = useState(true);

  //===========Check Login ================
  LoginCheck();
  const admininfo = Cookies.get("admininfo") ? JSON.parse(Cookies.get("admininfo")) : [];
  const AdminID = admininfo.length ? admininfo[0].ID : "";

  useEffect(() => {
    GetDeller();
  }, [params.DellerID]); // عند تغيير دالة المندوب يتم تحديث البيانات

  useEffect(() => {
    fetchIntervalRef.current = setInterval(() => {
      GetDeller(); // تحديث الموقع كل 5 ثواني
    }, 5000);
    return () => clearInterval(fetchIntervalRef.current); // عند إلغاء تحميل المكون يتم مسح التوقيت
  }, []);

  async function GetDeller() {
    try {
      const post = {
        ID: params.DellerID,
        Action: "AdminDellerInfo",
      };
      const response = await fetch(ApiAdmin + "/deller.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      const newLatitude = parseFloat(data[0].latitude);
      const newLongitude = parseFloat(data[0].longitude);
      SetDelleName(data[0].Name);
      SetDellerlocation(data[0].locationName);
      if (newLatitude !== center.lat || newLongitude !== center.lng) {
        Setcenter({
          lat: newLatitude,
          lng: newLongitude,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  function iconMarker(Icon) {
    const customIcon = new L.Icon({
      iconUrl: Icon,  // رابط الصورة
      iconSize: [32, 32],  // حجم الأيقونة
      iconAnchor: [16, 32],  // نقطة التثبيت
      popupAnchor: [0, -32],  // مكان ظهور البوب أب
    });
    return customIcon;
  }

  // تحديث المركز داخل الخريطة
  function MapUpdater() {
    const map = useMap(); // الوصول إلى خريطة Leaflet الحالية
    useEffect(() => {
      map.setView(center, map.getZoom()); // تحديث المركز تلقائيًا
    }, [center]); // إعادة التحديث عند تغير الـ center
    return null;
  }

  return (
    <>
      <Header_ />
      <div dir="rtl" className="row mt-0 text-center0 m-auto">
        <div className="col-12 p-0 text-center bg-white">
          <h3 className="text-orange fw-bold py-1">تتبع المندوب</h3>
          <h6>{DellerName}</h6>
          {Dellerlocation != "unknown" ? <small>{Dellerlocation}</small> : ""}
        </div>
        <div className="col-master col-12 mt-0 bg-light px-1 text-center">
          <div style={{ width: '100%', height: '100%' }} id="map">
            <MapContainer
              center={center}
              zoom={17}
              style={{ width: '100%', height: '100%' }}
            >
              {/* <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" /> */}

              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="&copy; <a href='https://www.esri.com/'>Esri</a>"
              />
              <MapUpdater /> {/* إضافة المكون لتحديث المركز */}
              {center && (
                <Marker position={center} icon={iconMarker(marker)}>
                  <Popup> الموقع : {center.lat}, {center.lng}</Popup>
                </Marker>
              )}
            </MapContainer>
          </div>
          <br />
        </div>
      </div>
    </>
  );
}
